import { getTenantTimeout, updateActiveUser } from "../services/loginPrerequisiteService";
import React, { useEffect } from "react";
import { removeLocalStorageItems } from "../utils/removeLocalStorageUtility";

function useLoginSuccess(isAuthenticated, setPageTitle, setUserType, setDefaultTimeout, navigate, instance, setLoginChecked) {
  useEffect(() => {
    if (!isAuthenticated) return;
    const shva = localStorage.getItem("shva");
   /*  if (!shva || shva === "undefined" || shva === "") {
      // Default SHVA
      localStorage.removeItem("Title");
      localStorage.setItem("shva", "R2zVUZUw0J/DR44Wub7X/Q==");
      setPageTitle("");
      setUserType("");

      // Fetch tenant timeout & login configuration
      getTenantTimeout()
        .then((result) => {
          const loginConfiguration = result.data;

          // Store values in localStorage and update React state
          localStorage.setItem("postLogoutRedirectUri", loginConfiguration.postLogoutRedirectUri);
          localStorage.setItem("shva", decodeURIComponent(loginConfiguration.shva));  
          localStorage.setItem("Title", loginConfiguration.title);
          localStorage.setItem("usertype", JSON.stringify(loginConfiguration.userType));
          localStorage.setItem("isVerticalTabPosition", loginConfiguration.isVerticalTabPosition);
          localStorage.setItem("decisionMaker", loginConfiguration.DecisionMaker);
          setPageTitle(loginConfiguration.title);
          setUserType(loginConfiguration.userType);

          // Handle timeout
          const timeout = parseInt(loginConfiguration.defaultTimeout, 10);
          if (timeout > 0) {
            setDefaultTimeout(timeout);
            localStorage.setItem("defaultTimeout", timeout);
          }

          setLoginChecked && setLoginChecked(true);
        })
        .catch(() => {
          setPageTitle("");
          setLoginChecked && setLoginChecked(true);
        });
    } else {
      // Already has SHVA, update active user
      if(isAuthenticated) {
        updateActiveUser("false").then(() => {
          setPageTitle(localStorage.getItem("Title") || "");
        });
      }
      setLoginChecked && setLoginChecked(true);
    } */
  }, [isAuthenticated, setPageTitle, setUserType, setDefaultTimeout, navigate, instance, setLoginChecked]);
}

export default useLoginSuccess;
